import LogoState from "../state/LogoState";
import PreloaderState from "../state/PreloaderState";
import GameState from "../state/game/GameState";
import { GameStates } from "onearm";
import { Idle } from "../state/game/states/Idle";
import { Spinning } from "../state/game/states/Spinning";
import { WinPresentation } from "../state/game/states/WinPresentation";
import { Restore } from "../state/game/states/Restore";
import { ErrorState } from "../state/game/states/ErrorState";
import { FreespinIntro } from "../state/game/states/FreespinIntro";
import { FreespinOutro } from "../state/game/states/FreespinOutro";
import { FreespinSpinning } from "../state/game/states/FreespinSpinning";
import { FreespinWinPresentation } from "../state/game/states/FreespinWinPresentation";
import { FreespinIdle } from "../state/game/states/FreespinIdle";
import { InfoPageState } from "../state/InfoPageState";
import { AutoplaySettingsState } from "../state/AutoplaySettingsState";
import { BuyFreeSpinsState } from "../state/BuyFreeSpinsState";
import { SystemSettingsPopupState } from "../state/SystemSettingsPopupState";
import { GameIntroState } from "../state/GameIntroState";
import { SandboxState } from "../state/SandboxState";
import { GameIntroScene } from "../scenes/intro/GameIntroScene";
import { GameBackground } from "../scenes/GameBackground";
import { ReelsScene } from "onearm";
import { HUDScene } from "../scenes/HUDScene";
import { SystemSettingsPopupScene } from "../scenes/SystemSettingsPopupScene";
import { WinsPopupScene } from "../scenes/WinsPopupScene";
import { InfoPopup } from "../scenes/infoPopup/InfoPopup";
import { ErrorPopupScene } from "../scenes/ErrorPopupScene";
import { FreeSpinOutroPopup } from "../scenes/FreeSpinOutroPopup";
import { FreeSpinIntroPopup } from "../scenes/FreeSpinIntroPopup";
import { TransitionScene } from "../scenes/TransitionScene";

import { slotConfig } from "./slot.config";
import { GameServices } from "./services.config";
import { PreloaderScene } from "../scenes/PreloaderScene";
import { ServicesConfig } from "onearm";

import { FontStyles } from "./FontStyles";
import { manifest } from "./resources-manifest";
import { AutoPlaySettingsScene } from "../scenes/autoplaySettings/AutoPlaySettingsScene.js";
import { BuyBonusPopUpScene } from "../scenes/buyBonusPopup/BuyBonusPopUpScene.js";
import { CascadeStrategy } from "onearm";

export const GameConfig = {
    gameId: "swb1-ysm",
    services: Object.assign({}, { ...ServicesConfig }, { ...GameServices }),
    resources: { manifest },
    styles: FontStyles,
    layers: {
        layers: [
            "background",
            "default",
            "underReels",
            "reels",
            "overReel",
            "stickySymbols",
            "paylineLayer",
            "symbolsAnimationLayer",
            "hud",
            "overHud",
            "popups",
        ],
    },
    data: {
        bet: 1,
        musicVolume: 80,
        sfxVolume: 100,
        volume: 80,
        isSoundsMuted: false,
        isMusicMuted: false,
        isSfxMuted: false,
        autoplayWinLimit: 250,
        autoplayLossLimit: 120,
        autoplayGameLimit: 10,
        spinType: "normal",// normal, quick, turbo
        skipScreen: false,
        dontShowAgainGameIntro: false,
    },
    initState: "LogoState",
    states: {
        LogoState: LogoState,
        PreloaderState: PreloaderState,
        GameIntroState: GameIntroState,
        SandboxState: SandboxState,
        GameState: {
            Class: GameState,
            states: {
                [GameStates.IDLE]: Idle,
                [GameStates.SPINNING]: Spinning,
                [GameStates.WINNING]: WinPresentation,
                [GameStates.InfoPageState]: InfoPageState,
                [GameStates.RESTORE]: Restore,
                [GameStates.ERROR]: ErrorState,
                [GameStates.FREE_SPIN_INTRO]: FreespinIntro,
                [GameStates.FREE_SPIN_OUTRO]: FreespinOutro,
                [GameStates.FREE_SPIN_SPINNING]: FreespinSpinning,
                [GameStates.FREE_SPIN_WINNING]: FreespinWinPresentation,
                [GameStates.FREE_SPIN_IDLE]: FreespinIdle,
                ["AutoplaySettingsState"]: AutoplaySettingsState,
                ["BuyFreeSpinsState"]: BuyFreeSpinsState,
                ["SystemSettingsPopupState"]: SystemSettingsPopupState,
            },
        },
    },
    scenes: {
        FreeSpinOutroPopup,
        FreeSpinIntroPopup,
        TransitionScene,
        GameIntroScene,
        GameBackground,
        HUDScene,
        ReelsScene,
        SystemSettingsPopupScene,
        AutoPlaySettingsScene,
        BuyBonusPopUpScene,
        WinsPopupScene,
        InfoPopup,
        ErrorPopupScene,
        PreloaderScene,
    },
    ...slotConfig,
    reelsConfig: {
        AnimationStrategy: CascadeStrategy,
        spinTime: {
            normal: 1200,
            quick: 1200,
        }
    }
};
